module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-header"
  }, [_c('tab', {
    attrs: {
      "prevent-default": false
    }
  }, [_c('tab-item', {
    attrs: {
      "selected": _vm.currentUser === 'newbie'
    },
    on: {
      "on-item-click": _vm.handleChange
    }
  }, [_vm._v("普通用户")]), _vm._v(" "), _c('tab-item', {
    attrs: {
      "selected": _vm.currentUser === 'upper'
    },
    on: {
      "on-item-click": _vm.handleChange
    }
  }, [_vm._v("购单用户")]), _vm._v(" "), _c('tab-item', {
    attrs: {
      "selected": _vm.currentUser === 'agent'
    },
    on: {
      "on-item-click": _vm.handleChange
    }
  }, [_vm._v("代理/经销商")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-content"
  }, [_vm._l((_vm.childList[_vm.currentUser]['list']), function(item) {
    return _c('group', {
      key: item.id
    }, [_c('cell', {
      attrs: {
        "title": 'ID：' + item.id,
        "link": '/uc/member/' + item.id,
        "is-link": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "inline-desc"
      },
      slot: "inline-desc"
    }, [_c('div', [_vm._v("昵称：" + _vm._s(item.nick_name ? item.nick_name : '用户尚未登录'))]), _vm._v(" "), _c('div', [_vm._v("等级：" + _vm._s(_vm._f("userLevel")(item)) + " "), (item.orderNumber) ? _c('span', {
      staticStyle: {
        "color": "red",
        "font-size": "80%",
        "opacity": "0.8"
      }
    }, [_vm._v("- 已购" + _vm._s(item.orderNumber) + "单")]) : _vm._e()])]), _vm._v(" "), _c('img', {
      staticStyle: {
        "padding-right": "10px"
      },
      attrs: {
        "slot": "icon",
        "width": "60",
        "src": item.headimgurl ? item.headimgurl : '/public/images/default_avatar_middle.jpg'
      },
      slot: "icon"
    })])], 1)
  }), _vm._v(" "), _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLoadMoreBtn),
      expression: "isShowLoadMoreBtn"
    }],
    attrs: {
      "show-loading": _vm.btnShowLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.getMore()
      }
    }
  }, [_vm._v("加载更多\n    ")]), _vm._v(" "), _c('divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowLoadMoreBtn),
      expression: "!isShowLoadMoreBtn"
    }]
  }, [_vm._v("没有更多数据了")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e7ad258"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/ChildList.vue
// module id = 700
// module chunks = 0